// extracted by mini-css-extract-plugin
module.exports = {"noteMenubar":"NoteMenubar_noteMenubar__2QPiM","toolTipLabel":"NoteMenubar_toolTipLabel__1emFZ"};